import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';

export default function ContactSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section
      id="contacto"
      data-testid="contact-section"
      ref={ref}
      className="bg-r2r-primary"
    >
      {/* CTA Band */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 lg:py-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2
            data-testid="contact-heading"
            className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-white leading-[0.95] mb-10"
          >
            Contáctanos
          </h2>
        </motion.div>

        {/* Contact Details Grid */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="grid md:grid-cols-3 gap-0 border border-white/15"
        >
          {/* Email */}
          <a
            href="mailto:Contacto@Ready2rent.cl"
            data-testid="contact-email"
            className="p-8 lg:p-10 border-b md:border-b-0 md:border-r border-white/15 group hover:bg-white/5 transition-colors"
          >
            <Mail size={20} className="text-white/40 mb-6 group-hover:text-r2r-wood transition-colors" />
            <span className="font-manrope text-xs font-bold uppercase tracking-[0.2em] text-white/40 block mb-2">
              Email
            </span>
            <span className="font-outfit text-lg font-semibold text-white flex items-center gap-2">
              Contacto@Ready2rent.cl
              <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </span>
          </a>

          {/* Phone */}
          <a
            href="tel:+56966052019"
            data-testid="contact-phone"
            className="p-8 lg:p-10 border-b md:border-b-0 md:border-r border-white/15 group hover:bg-white/5 transition-colors"
          >
            <Phone size={20} className="text-white/40 mb-6 group-hover:text-r2r-wood transition-colors" />
            <span className="font-manrope text-xs font-bold uppercase tracking-[0.2em] text-white/40 block mb-2">
              Teléfono
            </span>
            <span className="font-outfit text-lg font-semibold text-white flex items-center gap-2">
              +56 9 6605 2019
              <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </span>
          </a>

          {/* Address */}
          <div
            data-testid="contact-address"
            className="p-8 lg:p-10 group"
          >
            <MapPin size={20} className="text-white/40 mb-6" />
            <span className="font-manrope text-xs font-bold uppercase tracking-[0.2em] text-white/40 block mb-2">
              Dirección
            </span>
            <span className="font-outfit text-lg font-semibold text-white">
              Av Las Condes 7700
            </span>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="font-outfit font-extrabold text-lg text-white tracking-tight">
            Ready<span className="text-r2r-wood">2</span>Rent
          </span>
          <p className="font-manrope text-xs text-white/40">
            &copy; {new Date().getFullYear()} Ready2Rent. Todos los derechos reservados.
          </p>
        </div>
      </div>

      {/* ALSGroup */}
      <div className="bg-black py-8">
        <div className="flex flex-col items-center gap-4">
          <span className="font-manrope text-[11px] text-white/40 uppercase tracking-[0.2em]">Una empresa de</span>
          <img
            src="https://customer-assets.emergentagent.com/job_renovations-pro-1/artifacts/2wsalmgu_1.png"
            alt="ALSGroup.cl - Venture Studio Inmobiliario"
            data-testid="alsgroup-logo"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}
